import {ICacheClass, ICacheClassPromise, wrapCache} from "@gongt/ts-stl-server/database/cache";

const NodeCache = require("node-cache");
export const memoryCache: ICacheClassPromise = wrapCache(new NodeCache({stdTTL: 60, checkperiod: 90}));
export const memoryCacheOld: ICacheClass = new NodeCache({stdTTL: 60, checkperiod: 90});
